import { Component, OnInit } from '@angular/core';
import { FlowMode } from '../../../dto/enum/flow.mode.enum';
import { PublishFlowFacade } from '../../../facades/publish-flow.facade';

@Component({
    selector: 'app-property-start',
    templateUrl: './property-start.component.html',
    styleUrls: ['./property-start.component.scss'],
})
export class PropertyStartComponent implements OnInit {
    private readonly step = 'start';
    mode: FlowMode = FlowMode.CREATE;
    nextUrl = '';
    previousUrl = '';

    constructor(private readonly flow: PublishFlowFacade) {}

    ngOnInit(): void {
        // Entrada de creación NUEVA → resetea TODO el estado del wizard (desde 0).
        this.flow.startNew();
        this.flow.initStep(this.step);
        this.mode = this.flow.mode ?? FlowMode.CREATE;
        this.nextUrl = this.flow.nextUrl(this.step);
        this.previousUrl = this.flow.previousUrl(this.step);
    }

    handlePreviousStep(): void {
        this.flow.previous(this.step);
    }

    handleNextStep(): void {
        this.flow.next(this.step);
    }
}
